const axios = require('axios');

(() => {
  var formNum = 1;
  const userRegistrationCheckBox = '.dc-user-registration-check-box';
  const passwordForm = '.dc_password_form'
  const password = '.dc-password'
  const passwordConfirmation = '.dc-password-confirmation'
  const selectedCoupon = '.selected-day-caming-coupon-js'
  const notUseCoupon = '.not-use-day-camping-user-coupon-js';

  var mql = window.matchMedia('screen and (max-width: 915px)');

  const init = () => {
    if (location.href.indexOf('customer/day_camping/guest') < 1 ) {
      return
    }
    mql.addListener(fetchDayCampingReservationObj);
    const path = process.env.JS_BASE_URL + 'customer/day_camping/guest/new';
    $(passwordForm).hide();
    if ($('#data-day-camping-companions').data('day-camping-companions') != null && $('#data-day-camping-companions').data('day-camping-companions').length > 1) {
      var dayCampingCompanions = $('#data-day-camping-companions').data('day-camping-companions');
      formNum = dayCampingCompanions.length;
    }

    if (location.pathname === path  && localStorage.getItem('initial_user_registration_modal') === null) {
      $('#day-camping-login-confirmation-modal').click();
      localStorage.setItem('initial_user_registration_modal', 'on');
    } else if (location.pathname !== path && localStorage.getItem('initial_user_registration_modal') === 'on') {
      localStorage.removeItem('initial_user_registration_modal');
    }


    $('body')
      .on('click', userRegistrationCheckBox, togglePasswordForm)
      .on('change', '.dc-phone-format-js', phoneFormat)
      .on('change', '.dc-email-change-js', emailChange)
      .on('change', '.dc-check-companion-js', checkCompanion)
      .on('click', '.dc-user-add-js', addCompanionField)
      .on('click', selectedCoupon, changePrice)
      .on('click', notUseCoupon, removeCoupon);
  }
  $(init);

  const fetchDayCampingReservationObj = () => {
    if (mql.matches) {
      axios.get(process.env.JS_BASE_URL + 'customer/day_camping/guest/fetch_session')
      .then(response => {
        $('.day_camping_right_panel_block').html(response['data']);
      })
      .catch(error => {
        console.log(error);
        return error;
      })
    } else {
      axios.get(process.env.JS_BASE_URL + 'customer/day_camping/guest/fetch_session')
      .then(response => {
        $('.day-camping-guest').html(response['data']);
      })
      .catch(error => {
        console.log(error);
        return error;
      })
    }
  }

  const changePrice = e => {
    const $element = $(e.currentTarget);
    const userCouponId = $element[0].value;
    axios.defaults.headers['X-CSRF-TOKEN'] = $('meta[name=csrf-token]').attr('content');
    axios.post(process.env.JS_BASE_URL + 'customer/day_camping/guest/change', { user_coupon_id: userCouponId })
    .then(response => {
      if ( $(window).width() > 915 ) {
        $('.day-camping-guest').html(response['data']);
      } else {
        $('.day_camping_right_panel_block').html(response['data']);
      }
    })
    .catch(error => {
      console.log(error);
      return error;
    })
  }

  const removeCoupon = () => {
    axios.defaults.headers['X-CSRF-TOKEN'] = $('meta[name=csrf-token]').attr('content');
    axios.delete(process.env.JS_BASE_URL + 'customer/day_camping/guest/remove_coupon')
    .then(response => {
      if ( $(window).width() > 915 ) {
        $('.day-camping-guest').html(response['data']);
      } else {
        $('.day_camping_right_panel_block').html(response['data']);
      }
    })
    .catch(error => {
      console.log(error);
      return error;
    })
  }

  const phoneFormat = (e) => {
    e.preventDefault();
    $ele = $(e.currentTarget);
    $ele.val(z2hNum($ele.val()))
    $ele.val(removeHyphen($ele.val()))
  }

  const emailChange = (e) => {
    e.preventDefault();
    $ele = $(e.currentTarget);
    $($ele.data('email-confirmation')).val('')
  }

  const z2hNum = (str) => {
    return str.replace(/[０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    })
  }
  const removeHyphen = (str) => {
    return str.replace(/(\-|ー)/g, '');
  }
  const onlyNum = (str) => {
    return str.replace(/[^0-9]/g, '');
  }

  const togglePasswordForm = () => {
    if ($(userRegistrationCheckBox).prop('checked')) {
      $(password).prop('disabled', false);
      $(passwordConfirmation).prop('disabled', false);
      $(passwordForm).fadeIn();
    } else {
      $(password).prop('disabled', true);
      $(passwordConfirmation).prop('disabled', true);
      $(passwordForm).fadeOut();
    }
  }

  const addCompanionField = e => {
    const field = `<div class="camping-subscription-email mb-2"><input placeholder="例：mail@ushinohiroba.com" maxlength="250" class="dc-check-companion-js" size="250" type="text" name="day_camping_guest_registration_form[companions[${formNum}]]" id="day_camping_guest_registration_form_companions[${formNum}]" /><div class="check-email hide"><span></span></div><div class="error-message hide"><div class="invalid-camping-subscriber-email"><div class="email-icon"></div><div class="text">入力されたメールアドレスは定額キャンプに加入されていません。</div></div></div></div>`
    formNum++;
    $(e.currentTarget).before(field)
  }

  const checkCompanion = e => {
    e.preventDefault();
    const target = e.currentTarget
    const val = $(target).val()
    axios.get(process.env.JS_BASE_URL + 'api/v1/camping/camping_subscriptions', {
      params: {
        email: val
      }
    })
    .then(response => {
      console.log(response.data)
      if (response.data['result'] == 'ok') {
        $(target).siblings('.check-email').removeClass('hide')
        $(target).siblings('.error-message').addClass('hide')
      }
      else {
        $(target).siblings('.check-email').addClass('hide')
        $(target).siblings('.error-message').removeClass('hide')
      }
    })
  }
})();

